var _rect, _path, _rect2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYt = function SvgYt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    fill: "#FC4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.084 5.6665H6.91732C5.66732 5.6665 4.83398 6.49984 4.83398 7.74984V10.2498C4.83398 11.4998 5.66732 12.3332 6.91732 12.3332H11.084C12.334 12.3332 13.1673 11.4998 13.1673 10.2498V7.74984C13.1673 6.49984 12.334 5.6665 11.084 5.6665ZM9.78816 9.429L8.75898 10.0457C8.34231 10.2957 8.00064 10.104 8.00064 9.61651V8.37901C8.00064 7.89151 8.34231 7.69984 8.75898 7.94984L9.78816 8.5665C10.184 8.80817 10.184 9.1915 9.78816 9.429Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    stroke: "#121626",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yt.85bb7dbf.svg";
export { ForwardRef as ReactComponent };